/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * pref_idに相当
     * @type {string}
     * @memberof Location
     */
    prefectureId: string;
    /**
     * city_idに相当
     * @type {string}
     * @memberof Location
     */
    cityId: string | null;
    /**
     * <都道府県名> <市区町村名>
     * @type {string}
     * @memberof Location
     */
    name: string;
}

export function LocationFromJSON(json: any): Location {
    return LocationFromJSONTyped(json, false);
}

export function LocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Location {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prefectureId': json['prefecture_id'],
        'cityId': json['city_id'],
        'name': json['name'],
    };
}

export function LocationToJSON(value?: Location | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prefecture_id': value.prefectureId,
        'city_id': value.cityId,
        'name': value.name,
    };
}

